import { call, put, all, takeLatest } from "redux-saga/effects";

import { Collection, Item } from "./shop.types";

import { shopActions } from "./shop.reducer";

import {
  getAllCollection,
  getAllBrand,
  searchProductByCollection,
  getCollection,
  getProduct,
  countFilteredItems,
  searchProductByKeyword,
  getBrandById,
  countFromProducts,
} from "../../apis/shop.dashboard.apis";

import {
  getReviewsByProduct,
  getReviewsByUser,
  createReview,
  deleteReview,
  updateReview,
} from "../../apis/shop.services.apis";

// fetch All Collections Async
export function* fetchAllCollectionsAsync() {
  try {
    const collections: any[] = yield getAllCollection();

    yield put(shopActions.fetchAllCollectionsSuccess(collections));
  } catch (error) {
    yield put(shopActions.fetchAllCollectionsFailure(error));
  }
}

export function* fetchAllCollectionsStart() {
  yield takeLatest(
    shopActions.fetchAllCollectionsStart.type,
    fetchAllCollectionsAsync,
  );
}

// fetch All Brands Async
export function* fetchAllBrandsAsync() {
  try {
    const allBrands: any[] = yield getAllBrand();

    yield put(shopActions.fetchAllBrandsSuccess(allBrands));
  } catch (error) {
    yield put(shopActions.fetchAllBrandsFailure(error));
  }
}

export function* fetchAllBrandsStart() {
  yield takeLatest(shopActions.fetchAllBrandsStart.type, fetchAllBrandsAsync);
}

// fetch Items in a collection Async
export function* fetchCollectionItemsAsync(action: any) {
  try {
    const collectionItems: any[] = yield call(
      searchProductByCollection,
      action.payload,
    );

    yield put(shopActions.fetchCollectionItemsSuccess(collectionItems));
  } catch (error) {
    yield put(shopActions.fetchCollectionItemsFailure(error));
  }
}

export function* fetchCollectionItemsStart() {
  yield takeLatest(
    shopActions.fetchCollectionItemsStart.type,
    fetchCollectionItemsAsync,
  );
}

// fetch Items with a brand Async
export function* fetchBrandItemsAsync(action: any) {
  try {
    const brandItems: any[] = yield call(
      searchProductByKeyword,
      action.payload,
    );

    yield put(shopActions.fetchBrandItemsSuccess(brandItems));
  } catch (error) {
    yield put(shopActions.fetchBrandItemsFailure(error));
  }
}

export function* fetchBrandItemsStart() {
  yield takeLatest(shopActions.fetchBrandItemsStart.type, fetchBrandItemsAsync);
}

// fetch a collection Async
export function* fetchCollectionAsync(action: any) {
  try {
    const collection: Collection = yield call(getCollection, action.payload);

    yield put(shopActions.fetchCollectionSuccess(collection));
  } catch (error) {
    yield put(shopActions.fetchCollectionFailure(error));
  }
}

export function* fetchCollectionStart() {
  yield takeLatest(shopActions.fetchCollectionStart.type, fetchCollectionAsync);
}

// fetch a brand Async
export function* fetchBrandAsync(action: any) {
  try {
    const brand: any[] = yield call(getBrandById, action.payload);

    yield put(shopActions.fetchBrandSuccess(brand[0]));
  } catch (error) {
    yield put(shopActions.fetchBrandFailure(error));
  }
}

export function* fetchBrandStart() {
  yield takeLatest(shopActions.fetchBrandStart.type, fetchBrandAsync);
}

// fetch current filter with count Async
export function* fetchFilterWithCountAsync(action: any) {
  try {
    const filterWithCount: { FILTERS: any; EXTRAFILTERS: any } = yield call(
      countFilteredItems,
      action.payload,
    );

    yield put(shopActions.fetchFilterWithCountSuccess(filterWithCount));
  } catch (error) {
    yield put(shopActions.fetchFilterWithCountFailure(error));
  }
}

export function* fetchFilterWithCountStart() {
  yield takeLatest(
    shopActions.fetchFilterWithCountStart.type,
    fetchFilterWithCountAsync,
  );
}

// fetch filter for BRAND page Async
export function* fetchFilterForBrandAsync(action: any) {
  try {
    const filterForBrand: { FILTERS: any; EXTRAFILTERS: any } = yield call(
      countFromProducts,
      action.payload,
    );

    yield put(shopActions.fetchFilterForBrandSuccess(filterForBrand));
  } catch (error) {
    yield put(shopActions.fetchFilterForBrandFailure(error));
  }
}

export function* fetchFilterForBrandStart() {
  yield takeLatest(
    shopActions.fetchFilterForBrandStart.type,
    fetchFilterForBrandAsync,
  );
}

// fetch an item Async
export function* fetchItemAsync(action: any) {
  try {
    const product: Item = yield call(getProduct, action.payload);

    yield put(shopActions.fetchItemSuccess(product));
  } catch (error) {
    yield put(shopActions.fetchItemFailure(error));
  }
}

export function* fetchItemStart() {
  yield takeLatest(shopActions.fetchItemStart.type, fetchItemAsync);
}

// fetch reviews by product Async
export function* fetchReviewsByProductAsync(action: any) {
  try {
    const getReviewsResult: {
      reviews: any[];
      count: number;
      averageRate: number;
    } = yield call(getReviewsByProduct, action.payload);

    yield put(shopActions.fetchReviewsByProductSuccess(getReviewsResult));
  } catch (error) {
    yield put(shopActions.fetchReviewsByProductFailure(error));
  }
}

export function* fetchReviewsByProductStart() {
  yield takeLatest(
    shopActions.fetchReviewsByProductStart.type,
    fetchReviewsByProductAsync,
  );
}

// fetch reviews by user Async
export function* fetchReviewsByUserAsync(action: any) {
  try {
    const getReviewsResult: {
      reviews: any[];
      count: number;
    } = yield call(getReviewsByUser, action.payload);

    yield put(shopActions.fetchReviewsByUserSuccess(getReviewsResult));
  } catch (error) {
    yield put(shopActions.fetchReviewsByUserFailure(error));
  }
}

export function* fetchReviewsByUserStart() {
  yield takeLatest(
    shopActions.fetchReviewsByUserStart.type,
    fetchReviewsByUserAsync,
  );
}

export function* shopSagas() {
  yield all([
    call(fetchAllCollectionsStart),
    call(fetchAllBrandsStart),
    call(fetchCollectionItemsStart),
    call(fetchBrandItemsStart),
    call(fetchCollectionStart),
    call(fetchBrandStart),
    call(fetchItemStart),
    call(fetchFilterWithCountStart),
    call(fetchFilterForBrandStart),
    call(fetchReviewsByProductStart),
    call(fetchReviewsByUserStart),
  ]);
}
